<template>
<div>
<ContentHeader :title="$store.state.languages.lang_phrases.kullanici_bilgileri"  url="BrandUsers" :show_button="true"  icon="arrow-left" buttontype="danger" :label="$store.state.languages.lang_phrases.geri_don"></ContentHeader>

<template v-if="loading">
<FrameOverlay></FrameOverlay>
</template>


<template v-if="!loading">
<div class="mt-4">

<ClickEditInputText  title="Kullanıcı İsmi" :value="item.name" valkey="name" @dataChanged="dataChanged" />
<ClickEditInputText  title="Kullanıcı Email" :value="item.email" valkey="email" @dataChanged="dataChanged" />



<template v-if="$store.state.auth.userroles.includes('admin')">
  <ClickEditSwitch  :title="$store.state.languages.lang_phrases.yonetici" :value="item.is_admin" valkey="is_admin" @dataChanged="dataChanged" />
  <ClickEditMultiSelect :title="$store.state.languages.lang_phrases.yetkili_oldugu_projeler" :value="item.projects" :options="projects" valkey="projects" @dataChanged="dataChanged"  />
</template>


<template v-else>
  <template v-if="is_editor_admin && $store.state.auth.user.id !==item.user.id">
    <ClickEditSwitch  :title="$store.state.languages.lang_phrases.yonetici" :value="item.is_admin" valkey="is_admin" @dataChanged="dataChanged" />
    <ClickEditMultiSelect :title="$store.state.languages.lang_phrases.yetkili_oldugu_projeler" :value="item.projects" :options="projects" valkey="projects" @dataChanged="dataChanged"  />
  </template>
</template>








</div>
</template>



</div>
</template>

<script>
export default {

  name: 'BrandUser',

   data () {
    return {
      item:null,
      loading:true,
      projects:[],
      is_editor_admin:null,
    }
  },
  computed:{
    appurl()
    {
      return process.env.VUE_APP_APP_ROOT
    }
  },
  mounted()
  {
    this.getData()
  },
  methods:{
    async getData()
    {
      console.log("getdata")
      this.projects = await this.generalApiGetWithoutLoader("brand_projects/"+this.$route.params.id)
      this.is_editor_admin = await this.generalApiGetWithoutLoader("brand_user_is_admin")
      let item = await this.generalApiGetWithoutLoader("brand/user/"+this.$route.params.user_id)
      await console.log(item);
      item = await this.mapProjects(item)
      this.item = await item
      this.loading = await false
    },
    mapProjects(user)
    {
      let arr = []
      for(let element of user.projects)
      {
        element.id = element.project.id
        element.name = element.project.name
        arr.push(element)
      }
      user.projects = arr
      return user

    },
    dataChanged(data)
    {
      console.log(data.value)
      console.log(data.key)      
      let formdata = new FormData()
      
      if(data.key=="projects")
      {
        formdata.append(data.key,JSON.stringify(data.value))
      }
      else
      {
        formdata.append(data.key,data.value)
      }
      //return false
      this.generalSubmission(formdata,"brand/user/update/"+this.item.id,this.afterdataChanged)
    },
    afterdataChanged(response)
    {
      console.log("data changed");
      console.log(response.data);
      let item = this.mapProjects(response.data)
      this.item = response.data
      this.$store.dispatch('users/setUser',this.item) 
      
    }
   
    
    
  }
};
</script>

<style lang="css" scoped>
</style>